import { DIndex } from "./desktop/Index"
import { MIndex } from "./devices/mobile/Index"
import { VM } from "../../core/VM"

export const Speakout = ({match}) => {
    let view = VM()
    return (
    
        view === '' ?
            <DIndex match={match.params}/>
        :
            <MIndex match={match.params}/>
    )
}   